import { APIRoute } from '@/modules/utils'
import { PureObject } from 'emt-library'
import { ConnectedUserAnimal } from '@/dataV3/Animal/ConnectedUserAnimal'

export type Body = Omit<
  PureObject<ConnectedUserAnimal>,
  'id' | 'acquisitionStatus' | 'reviewsSummary' | 'mainPictureThumbnailUrl'
>

export type Response = ConnectedUserAnimal

export type UrlParams = {
  animalId: string
}

export const Route: APIRoute = {
  method: 'PUT',
  path: `/members/animals/:animalId`,
}
